import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aanmelden',
  templateUrl: './aanmelden.component.html',
  styleUrls: ['./aanmelden.component.scss']
})
export class AanmeldenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
